module.exports = __webpack_public_path__ + "img/s2.34f366b5.png";